import * as tenantApi from 'api/tenant-api';
import { getDatabase } from 'database';
import { Guid } from 'types/guid';

export const DEVICE_ID: string = 'DEVICE_ID';

export async function getDeviceId(): Promise<Guid> {
  const db = await getDatabase();
  const deviceId = await db.read(db.config.indexes.Device, DEVICE_ID) as Guid;
  return deviceId;
}

export async function generateDeviceId(): Promise<Guid> {
  let deviceId = await getDeviceId();
  if (!deviceId) {
    deviceId = Guid.newGuid();
    const db = await getDatabase();
    await db.add(db.config.indexes.Device, deviceId, DEVICE_ID);
  }
  return deviceId;
}

export async function unregisterDevice(tenantId: Guid, username: string): Promise<void> {
  const deviceId = await getDeviceId();
  await tenantApi.unregisterDevice(tenantId, deviceId, username);
}


// WEBPACK FOOTER //
// ./src/services/device-service.ts